/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Проп содержит опции для конфига chart.js
 * Эти часто используемые опции вынесены в отдельный проп для удобства конфигурации
 * */

export var EDatasetColors = /*#__PURE__*/function (EDatasetColors) {
  EDatasetColors["RED"] = "red";
  EDatasetColors["BLUE"] = "blue";
  EDatasetColors["ORANGE"] = "orange";
  return EDatasetColors;
}({});
export var EDatasetColorTypes = /*#__PURE__*/function (EDatasetColorTypes) {
  EDatasetColorTypes["GRADIENT"] = "gradient";
  EDatasetColorTypes["SOLID"] = "solid";
  EDatasetColorTypes["TRANSPARENT"] = "transparent";
  return EDatasetColorTypes;
}({});